
    <ul class="option-list">
      <ng-content></ng-content>
    </ul>
  